const ApiVersion = (api_version: number) => {
  return API_VERSIONS.filter( (item) => item.value === api_version )[0]
}

const ApiColor = (version: number) => {
  return ['', 'orange', 'purple', 'green', 'blue'][version]
}

const API_VERSIONS = [
  { text: 'Nora V1', value: 1, disabled: true },
  { text: 'Nora', value: 2 },
  { text: 'EiTV', value: 3 },
  { text: 'SatTV', value: 4 },
  { text: 'None', value: 0 },
]

export { API_VERSIONS, ApiVersion, ApiColor }

